/*
 * File: Referrals.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the link page for patients referrals
 */
import React, { useState, useEffect } from "react";
import UINotFound from "components/ui/UINotFound";
import PatientIdStore from "../store/PatientIdStore";
import PropTypes from "prop-types";
import UILinkList from "components/ui/UILinkList";
import Api from "../store/Api";
import UIProgress from "components/ui/UIProgress";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PatientChart from "services/patients/topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-2.5),
    marginTop: theme.spacing(2.5)
  }
});

const Referrals = ({ match, classes }) => {
  const patientId = match.params.patientId || PatientIdStore.getId();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferrals = async () => {
      const referrals = await Api.referrals(patientId);
      setReferrals(referrals);
      setLoading(false);
    };
    fetchReferrals();
  }, [patientId]);

  /**
   * Returns a url string for the referral link
   *
   * @param {Number}
   */
  const getLink = referralId => {
    return "/patients/" + patientId + "/referrals/" + referralId;
  };

  const links = referrals.map(referral => {
    return {
      primaryString: referral.first + " " + referral.last,
      secondaryString: referral.company,
      url: getLink(referral.referralId)
    };
  });

  if (loading) return <UIProgress />;

  if (referrals.isNullOrEmpty()) {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader pageTitle="Referrals" pageSubtitle="Patient" />
        </Toolbar>
        <UINotFound message="This Patient Has No Referrals" />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader pageTitle={"Referrals"} pageSubtitle={"Patient"} />
      </Toolbar>
      <UILinkList links={links} divider />
    </React.Fragment>
  );
};

Referrals.propTypes = {
  match: PropTypes.object,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Referrals);
